import { defineMessages } from 'react-intl'

export default defineMessages({
    placeLabel: {
        defaultMessage: 'Dónde',
    },
    placePlaceholder: {
        defaultMessage: 'Ej.: Calle, ciudad...',
    },
    vehicleTypeLabel: {
        defaultMessage: 'Tipo de vehículo',
    },
})
